import { 
    yellow,
    red,
    blue,
    axisName,
    pageBg
} from './color'
import util from '@/utils/util.js'

export var getBottom = function(dataZoom=true){
  var axis = {
    position: 'bottom',
    type: 'point',
    $dataIndex: 0,
    $dataZoomIndex: 0,
    dataKey: 'date',
    barGap: '20%',
    paddingInner: '60%',
    paddingOuter: '40%',
    intervalLength: 69,
    tickValues: function (domain) {
        var n = domain.length - 1;
        if (n < 6) {
            return [domain[0]];
        } else if (n < 10) {
            return [domain[0], domain[n]];
        } else {
            var split = n / 6;
            return [domain[Math.round(n / 6)], domain[Math.round(n * 3 / 6)], domain[
                Math.round(n * 5 / 6)]];
        }
    },
    tick: {
      show: false
    },
    line: {
      show: false
    },
    label: {
      inRange: true,
      padding: 10,
      formatter:function(d){
        return d.substr(0,4)+'-'+d.substr(4, 2)+'-'+d.substr(6, 2);
      },
      style: {
        fill: axisName,
        fontSize: 10
      }
    }
  }
  if (!dataZoom) {delete axis.$dataZoomIndex}
  return axis
}

export var getBottomBar = function(dataZoom=true){
  let axis = getBottom(dataZoom);
  axis.type = 'band';
  return axis
}

export var getLeft = function(u='', labelTopColor='#A6A9AE'){
  return {
    position: 'left',
    type: 'linear',
    xOrY: 'y',
    splitNumber: 5,
    tick: {
      show: false
    },
    line: {
      show: false
    },
    tickValues: function(domain){
      var min = domain[0];
      var max = domain[1];
      var detar = max - min;
      return [domain[0], detar / 4 + domain[0], detar * 2 / 4 + domain[0], detar * 3 /
          4 + domain[0], domain[1]
      ];
    },
    splitLine: {
        show: true, // {boolean} 是否显示分隔线。
        // {object|function}分隔线样式
        style: {
            color: '#25262A',
            lineWidth: 1
        }
    },
    label: {
      padding: 4,
      // inRange: true,
      formatter: function(value, index, total){
        let data = util.number.getUnitNumber(value, 1, 0)
        if (Math.abs(value)<8) {data = value.toFixed(2)}
        let unit = util.number.getUnitNumber(value, 0, 2)
        if (unit === '万亿') {
          unit = '亿';
          data = data*10000
        }

        if (index === total-1 && unit != 0) {
          return unit
        }
        return data
      },
      style: function(value, index, data, totalArr){
        if (totalArr.length -1 === index) {
          return {
            fill: labelTopColor,
            fontSize: 12
          }
        }
        return {
          fill: axisName,
          fontSize: 10
        }
      }
    }
  }
}


export var getRight = function(unit='', labelTopColor = '#A6A9AE'){
  var axis = getLeft();
  axis.position = 'right';
  axis.splitLine.show = false;
  axis.label.formatter = function(value, index, total){
    if (index === total-1 && unit) {
      return unit
    }
    return value.toFixed(0)
  }

  axis.label.style = function(value, index, data, totalArr){
    if (totalArr.length -1 === index) {
      return {
        fill: labelTopColor,
        fontSize: 12
      }
    }
    return {
      fill: axisName,
      fontSize: 10
    }
  }
  return axis;
}